import { useMemo } from 'react';
import { Table } from 'antd';
import classnames from 'classnames/bind';
import { formatYYYYMMDDHHmm } from '@commonPackage/utils';
import type { ColumnsType } from 'antd/es/table';
import type { CluesReferrerReturnType } from '@portalCommon/services/recommend';
import { BaseModal, ModalCommonType } from '.';

import styles from './index.module.less';

const cx = classnames.bind(styles);

type RecommendTableProps = ModalCommonType & { list: CluesReferrerReturnType['items'] };

// 查看我的推荐数据表格
export function RecommendTableModal(props: RecommendTableProps) {
  const { onClose, list } = props;

  // 数据长度过多才显示滚动条，直接赋值滚动条会一直存在
  const scroll = useMemo(
    () =>
      list.length > 8
        ? {
            scroll: { y: 300 },
          }
        : {},
    [list.length],
  );

  const columns: ColumnsType<CluesReferrerReturnType['items'][0]> = [
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
    },
    {
      title: '联系方式',
      dataIndex: 'phone',
      key: 'phone',
      align: 'center',
    },
    {
      title: '公司名称',
      dataIndex: 'orga_name',
      key: 'orga_name',
      align: 'center',
    },
    {
      title: '提交时间',
      key: 'create_time',
      dataIndex: 'create_time',
      align: 'center',
      render: create_time => formatYYYYMMDDHHmm(create_time, '-'),
    },
  ];
  // 添加背景色
  const rowClassName = <T,>(_: T, index: number) => ((index + 1) % 2 ? cx('bg-color') : '');
  // 空数据展示
  const localeData = {
    emptyText: (
      <>
        <img
          src="https://static.fuxi.netease.com/yaotai/portal/index/lhtyxgwg_933327.png"
          style={{
            width: 200,
            height: 150,
            marginTop: 70,
          }}
          alt=""
        />
        <p>暂无数据</p>
      </>
    ),
  };

  return (
    <BaseModal onClose={onClose}>
      <div className={cx('recommend-table')}>
        <h6 className={cx('modal-title')}>我的推荐</h6>
        <Table
          columns={columns}
          dataSource={list}
          pagination={false}
          rowClassName={rowClassName}
          locale={localeData}
          rowKey={record => record.create_time + record.phone}
          {...scroll}
        />
      </div>
    </BaseModal>
  );
}
